export default __webpack_public_path__ + "static/media/0c231cf5dee7bc856755739d3661775c1602165709848.1fbefda2.webp";